import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
import { useEffect } from 'react';
import { useLocale } from '@/lib/i18n';
import { useLanguageStore } from '@/stores/languageStore';

/**
 * A visitor on /hi/ has chosen Hindi; carry that into the app (chat answers,
 * app nav) instead of making them pick it again. Only for languages the chat
 * supports — the store's type is the contract.
 */
function LocaleSync() {
  const locale = useLocale();
  const language = useLanguageStore((s) => s.language);
  const setLanguage = useLanguageStore((s) => s.setLanguage);
  useEffect(() => {
    if ((locale === 'hi' || locale === 'mr') && language !== locale) setLanguage(locale);
  }, [locale, language, setLanguage]);
  return null;
}

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-950 cosmic-bg">
      <ScrollToTop />
      <LocaleSync />
      <Header />
      <main className="relative z-10 flex-1 flex flex-col">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
